import * as Isotope from 'isotope-layout';
import * as InfiniteScroll from 'infinite-scroll';
import * as ImagesLoaded from 'imagesloaded';

export default {
    init() {

        (function () {

            // check that the grid exists
            var grid = document.querySelector('.isotope-grid');
            if (grid == null) {
                return;
            }

            // use this to check all of the checkbox values
            function manageFilter() {
                // map the input values in an array
                var inclusives = [];
                // grab all of the checkboxes
                var checkboxes = document.getElementsByName('search-filter[]');
                // inclusives filter from the checkbox
                for (var i = 0; i < checkboxes.length; i++) {
                    var checkbox = checkboxes[i];

                    // grab all of the checked checkboxes
                    if (checkbox.checked) {
                        inclusives.push(checkbox.getAttribute('data-filter'));
                    }
                }
                // combine all of the inclusives text togother
                var filterValue = inclusives.length ? inclusives.join(', ') : '.blank';
                return filterValue;
            }

            var iso = new Isotope(grid, {
                itemSelector: '.isotope-grid__item',
                layoutMode: 'vertical',
                getSortData: {
                    category: '[data-category]',
                },
            });

            var filtersElem = document.querySelector('#search-filter');
            filtersElem.addEventListener('change', function () {
                var filterValue = manageFilter();

                if (filterValue == null) {
                    return;
                }

                // use matching filter function
                iso.arrange(
                    {
                        filter: filterValue,
                    }
                );
            });

            // var pagination = document.querySelector('.pagination');
            // if (pagination !== null) {
            // infinite scroll
            InfiniteScroll.imagesLoaded = ImagesLoaded;
            new InfiniteScroll(grid, {
                path: '.pagination__button--next',
                append: '.isotope-grid__item',
                outlayer: iso,
                hideNav: '.pagination',
                status: '.page-load-status',
            });
        })();

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/searchpage.js